// extracted by mini-css-extract-plugin
export default {"root":"style_root__aqHFV","navbar":"style_navbar__JUlGz","scrollbar":"style_scrollbar__1wVBs"};